import { ContentItem } from '../../shared/interfaces';

// Correlate start/completion and reconnect replay without duplicating activity.
export function applySkillRead(content: ContentItem[], payload: any): ContentItem[] {
  if (!payload || typeof payload.skill !== 'string' || !payload.skill ||
      typeof payload.tool_call_id !== 'string' || !payload.tool_call_id ||
      !['loading', 'loaded', 'error'].includes(payload.status)) return content;
  const index = content.findIndex((item: any) => item.type === 'tool_action' &&
    item.tool === 'skill_read' && item.args?.[0]?.tool_call_id === payload.tool_call_id);
  const previous: any = index >= 0 ? content[index] : undefined;
  if (previous && previous.args?.[0]?.status !== 'loading' && payload.status === 'loading') return content;
  const item: ContentItem = { type: 'tool_action', tool: 'skill_read',
    queries: [payload.skill], args: [payload], pending: payload.status === 'loading' };
  if (index < 0) return [...content, item];
  return content.map((old, i) => i === index ? item : old);
}
